<template>
    <span  :class="classes" :style="style">
      {{ statusLabel }}
    </span>
</template>

<script setup>
import { computed } from 'vue';
import './badge.css';

const props = defineProps({
  status: {
    type: String,
    validator: function (value) {
      // Allow empty/initial values and normalize case from callers.
      if (value == null || value === "") return true;
      const normalized = String(value).toLowerCase();
      return [
        "draft",
        "active",
        "retired",
        "inactive",
        "archived",
        "pending",
        "relieved",
        "terminated",
        "detached",
      ].includes(normalized);
    },
  },
  backgroundColor: {
    type: String,
  },
  archived: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  // Renders any status as the neutral grey pill (bg #F9FAFB / border #EAECF0 /
  // text #344054) instead of the status-specific palette — used for the
  // Retired/Disabled row state of JobCategoriesList (ER-11346).
  neutral: {
    type: Boolean,
    default: false,
  },
  // Overrides the text derived from `status` (e.g. "Published" for the active status).
  label: {
    type: String,
    default: undefined,
  },
});

const classes = computed(() => {
  const normalizedStatus = (props.status || "").toLowerCase();
  const isArchived = normalizedStatus === "archived" || props.archived;
  return {
    'archive-badge': isArchived,
    'storybook-badge': !isArchived,
    [`storybook-badge--${normalizedStatus}`]: !isArchived && !props.neutral,
    'storybook-badge--neutral': !isArchived && props.neutral,
    'is-disabled': props.disabled
  };
});

const style = computed(() => {
  const normalizedStatus = (props.status || "").toLowerCase();
  if (normalizedStatus === "archived" || props.archived) {
    return null;
  }
  return {
    backgroundColor: props.backgroundColor
  };
});

const statusLabel = computed(() => {
  if (props.label) return props.label;
  const normalizedStatus = (props.status || "").toLowerCase();
  if (normalizedStatus === "archived" || props.archived) return "Archived";
  if (!props.status) return "";
  return normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
});

</script>
